import { ButtonGroup, IconButton, Stack, Tooltip, useColorModeValue } from '@ecoinvent/ui';
import { useReactFlow } from '@xyflow/react';
import { FiDownload, FiMaximize2, FiMinimize2, FiMinus, FiPlus } from 'react-icons/fi';

type Props = {
  isFullScreen: boolean;
  onToggle: () => void;
  onDownload: () => void;
};

const GraphControls = ({ isFullScreen, onToggle, onDownload }: Props) => {
  const { zoomIn, zoomOut } = useReactFlow();
  const bg = useColorModeValue('white', 'gray.700');
  const iconColor = useColorModeValue('gray.700', 'gray.100');
  const hoverBg = useColorModeValue('gray.50', 'gray.600');

  const buttonProps = {
    size: 'sm' as const,
    bg,
    color: iconColor,
    _hover: { bg: hoverBg },
    borderRadius: 'md',
    boxShadow: 'sm',
  };

  const fullscreenLabel = isFullScreen ? 'Exit fullscreen' : 'Enter fullscreen';

  return (
    <Stack spacing={2} alignItems="flex-end" pointerEvents="auto">
      <Tooltip label="Download graph" hasArrow placement="left">
        <IconButton aria-label="Download graph" icon={<FiDownload size={16} />} onClick={onDownload} {...buttonProps} />
      </Tooltip>
      <Tooltip label={fullscreenLabel} hasArrow placement="left">
        <IconButton
          aria-label={fullscreenLabel}
          icon={isFullScreen ? <FiMinimize2 size={16} /> : <FiMaximize2 size={16} />}
          onClick={onToggle}
          {...buttonProps}
        />
      </Tooltip>
      <ButtonGroup size="sm" isAttached orientation="vertical">
        <IconButton aria-label="Zoom in" icon={<FiPlus size={16} />} onClick={() => zoomIn()} {...buttonProps} />
        <IconButton aria-label="Zoom out" icon={<FiMinus size={16} />} onClick={() => zoomOut()} {...buttonProps} />
      </ButtonGroup>
    </Stack>
  );
};

export default GraphControls;
